/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Checkbox } from '../../../canvasComponents/index';
import { IntlProvider } from 'react-intl';
import CustomCheckboxEditForm from './CustomCheckbox.settingsForm';
import getLocalParams from '../localizationCustoms';

const CustomCheckbox = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      name: props.name,
    };

    this.setValue = this.setValue.bind(this);
  }

  setValue = () => {
    const { value } = this.state;
    const { onChange } = this.props || null;

    value && value.value === true
      ? this.setState({
        value: { value: false, review: { label: this.props.component.useReviewLabel ? this.props.component.reviewLabel : this.props.component.label } },
      }, () => {
        onChange(this.state.value);
      })
      : this.setState({
        value: { value: true, review: { label: this.props.component.useReviewLabel ? this.props.component.reviewLabel : this.props.component.label } },
      }, () => {
        onChange(this.state.value);
      });
  };

  render() {
    const { value } = this.state;
    return (
      <Checkbox
        onChange={() => this.setValue()}
        checked={value?.value}
        style={{ margin: '0px', padding: '0px' }}
        name="check"
        id={`id_checkbox${Math.random() * 0xffffffffffff}`}
        key={`key_checkbox${Math.random() * 0xffffffffffff}`}
        disabled={this.props.disabled}
      >
        {this.state.name}
      </Checkbox>
    );
  }
};

export default class CheckboxComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Checkbox',
      group: 'basic',
      icon: 'check-square',
      documentation: '',
      weight: 50,
      schema: CheckboxComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customcheckbox',
        dataGridLabel: false,
        labelPosition: 'right',
      },
      ...extend,
    );
  }

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  static editForm = CustomCheckboxEditForm;

  async attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    await element.getElementsByTagName('input').value;

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomCheckbox
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          name={this.name} // The name of the component
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  async detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
